import { render, staticRenderFns } from "./UserRecords.vue?vue&type=template&id=29c8f5ff"
import script from "./UserRecords.vue?vue&type=script&lang=js"
export * from "./UserRecords.vue?vue&type=script&lang=js"
import style0 from "./UserRecords.vue?vue&type=style&index=0&id=29c8f5ff&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports